import React, { useEffect, useState } from "react";
import { Button, Checkbox, ConfigProvider, DatePicker, Empty, Input, Modal, Select, TimePicker, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { API_DOMAIN } from "../../constants";
import axios from "axios";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";

const AddressManagementModal = ({ customerAddressManagementOpen, handleCustomerAddManageClose, createDeliveryJobLoading, createShipdayDeliveryJob, setLinkTitleHandler, handleCustomerAddressEditOpen, setSelectedDeliveryAddress, editSpecificCustomerAddress, linkTitle, selectedDeliveryAddress, saveAddressLoading, saveCustomerAddress, selectedDeliveryDriver, setSelectedDeliveryDriver, deliveryInstruction, setDeliveryInstruction, trackingLinkShare, setTrackingLinkShare, expectedDeliveryDate, setExpectedDeliveryDate, expectedDeliveryTime, setExpectedDeliveryTime }) => {



    const [deliveryDrivers, setDeliveryDrivers] = useState(null)

    const get_delivery_drivers = async () => {
        const data = await axios.get(`${API_DOMAIN}/shipday/get_all_drivers_info`);
        setDeliveryDrivers(data.data.data.map(e => ({ value: e.id, label: e.name })))
    }

    useEffect(() => {
        setSelectedDeliveryDriver(null)
        setDeliveryDrivers(null)
        setTrackingLinkShare(true)
        setExpectedDeliveryDate(null)
        setDeliveryInstruction(null)
        setExpectedDeliveryTime(null)
        setSelectedDeliveryAddress(null)
        get_delivery_drivers();
    }, [customerAddressManagementOpen?.open]);

    return (
        <div>
            < Modal
                title={`Manage Customer Delivery preferences`}
                open={customerAddressManagementOpen?.open}
                onCancel={handleCustomerAddManageClose}
                centered
                width={650}
                maskClosable={false}
                footer={
                    < div className="flex justify-between" >
                        <div className="flex align-middle" style={{ fontSize: "12px", fontWeight: "550" }}>
                            <i>
                                Current status of Query :&nbsp;
                            </i>
                            <div style={{ color: `${customerAddressManagementOpen?.data?.status == "Confirmed & Paid" ? "#41c44c" : "#ff5252"}` }}>
                                {customerAddressManagementOpen?.data?.status || "Unknown"}
                            </div>
                        </div>

                        <div>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Button: {
                                            defaultHoverColor: "#ffffff",
                                            defaultColor: "#ffffff",
                                            defaultHoverBg: "#3be368",
                                            defaultBg: "#31bd56",
                                        },
                                    },
                                }}
                            >
                                <Tooltip title={customerAddressManagementOpen?.data?.customer_info?.addresses?.length > 0 ? `Select address and click here to create a new delivery job to Shipday` : `Add the delivery address first to create a delivery job`}>
                                    <Button
                                        disabled={customerAddressManagementOpen?.data?.customer_info?.addresses?.length > 0 ? false : true}
                                        onClick={() => createShipdayDeliveryJob()}
                                        loading={createDeliveryJobLoading}
                                    >Create Delivery Job
                                    </Button>
                                </Tooltip>
                            </ConfigProvider>
                        </div>
                    </div >

                }>
                <div className="gap-2 grid border rounded drop-shadow p-2" style={{ backgroundColor: "#f7f7f7" }}>

                    {/* Top search bar */}
                    <div className="flex gap-1 justify-between">
                        <Input
                            maxLength={50}
                            placeholder="Search in Address"
                            allowClear
                            required
                            value={linkTitle}
                            onChange={(e) => {
                                setLinkTitleHandler(e.target.value);
                            }}
                        />
                        <ConfigProvider
                            theme={{
                                components: {
                                    Button: {
                                        defaultHoverColor: "#ffffff",
                                        defaultHoverBg: "#3be368",
                                        defaultBg: "#31bd56",
                                    },
                                },
                            }}
                        >
                            <Button
                                onClick={handleCustomerAddressEditOpen}
                            >Add New
                            </Button>
                        </ConfigProvider>
                    </div>
                    <div className="border rounded p-2 gap-2 grid overflow-y-auto drop-shadow-1" style={{ backgroundColor: "#bdd6b8", maxHeight: "50vh" }}>

                        {customerAddressManagementOpen?.data?.customer_info?.addresses?.length > 0 ? (customerAddressManagementOpen?.data?.customer_info?.addresses.map((e) => (
                            <div key={e.id} onClick={() => setSelectedDeliveryAddress(e)} className="border cursor-pointer rounded p-2 m-1" style={{ backgroundColor: `${selectedDeliveryAddress?.id == e.id ? "gray" : "white"}`, color: `${selectedDeliveryAddress?.id == e.id ? "white" : "black"}`, transition: "background-color 0.15s, color 0.15s ease-in-out" }}>
                                <div className="flex justify-between">
                                    <span className="pt-1 pb-1 pl-2 pr-2 rounded" style={{ color: "#878787", backgroundColor: "#f0f0f0", fontWeight: 550, fontSize: "11px" }}>{e.type}</span>
                                    {e?.default ? (<span className="pt-1 pb-1 pl-2 pr-2 rounded" style={{ color: "#878787", backgroundColor: "#f0f0f0", fontWeight: 550, fontSize: "11px" }}>Default Address</span>) : null}
                                    <div className="gap-2 flex">
                                        <span>
                                            <EditOutlined className="cursor-pointer hover:scale-125 active:scale-100 transition-transform duration-50 ease-in-out" onClick={() => editSpecificCustomerAddress(e)} />
                                        </span>
                                        <span disabled={saveAddressLoading}>
                                            <DeleteOutlined style={{ color: "#ff7c73" }} className="cursor-pointer hover:scale-125 active:scale-100 transition-transform duration-50 ease-in-out"
                                                onClick={() => saveCustomerAddress(e.id)} />
                                        </span>
                                    </div>
                                </div>
                                {/* address blocks */}
                                <div className="mt-1" style={{ fontWeight: 550 }}>
                                    <span>{e.name}</span><span className="ml-4">{e.number}</span>
                                </div>
                                <div>{e.address}</div>
                            </div>
                        ))) :
                            (<Empty />)}
                    </div>

                    <div className="border rounded mt-1.5 p-2 drop-shadow-1" style={{ backgroundColor: "#bdd6b8" }}>

                        <div style={{ width: "100%" }}>
                            <Select
                                allowClear
                                style={{ width: "100%" }}
                                optionFilterProp="label"
                                placeholder="Select Driver"
                                value={selectedDeliveryDriver}
                                onChange={(e) => {
                                    setSelectedDeliveryDriver(e)
                                }}
                                options={deliveryDrivers}
                            />
                        </div>



                        <div className="flex mt-2 mb-1">

                            {/* Delivery Date */}
                            <div>
                                <DatePicker
                                    style={{ width: "200px" }}
                                    placeholder="Expected Delivery Date"
                                    disabledDate={(current) => current && current < dayjs().startOf("day")}
                                    onChange={(e) => setExpectedDeliveryDate(e)}
                                    value={expectedDeliveryDate}
                                />
                            </div>

                            {/* Delivery Time */}
                            <div className="ml-1">
                                <TimePicker
                                    style={{ width: "200px" }}
                                    use12Hours
                                    placeholder="Expected Delivery Time"
                                    format="h:mm a"
                                    value={expectedDeliveryTime}
                                    onChange={(e) => setExpectedDeliveryTime(e)}
                                    disabledTime={() => {
                                        // If expectedDeliveryDate is in the future, unlock everything
                                        if (expectedDeliveryDate && dayjs(expectedDeliveryDate).isAfter(dayjs(), "day")) {
                                            return {}; // no disabled hours/minutes
                                        }

                                        // Otherwise, apply your current restriction logic
                                        const now = dayjs();
                                        return {
                                            disabledHours: () =>
                                                Array.from({ length: 24 }, (_, i) => (i < now.hour() ? i : -1)).filter(i => i !== -1),
                                            disabledMinutes: (selectedHour) => {
                                                if (selectedHour === now.hour()) {
                                                    return Array.from({ length: 60 }, (_, i) => (i < now.minute() ? i : -1)).filter(i => i !== -1);
                                                }
                                                return [];
                                            },
                                        };
                                    }}
                                />
                            </div>
                            <div className="ml-2">
                                <Checkbox
                                    checked={trackingLinkShare}
                                    onChange={(e) => setTrackingLinkShare(e.target.checked)}
                                    style={{ fontSize: "12px" }}
                                    className="flex align-middle"
                                >
                                    Share Tracking Link to customer in WATI
                                </Checkbox>
                            </div>
                        </div>

                        <div className="mt-1">
                            <TextArea
                                allowClear
                                rows={2}
                                placeholder="Enter delivery instructions"
                                value={deliveryInstruction}
                                onChange={(e) => setDeliveryInstruction(e.target.value)}
                            />
                        </div>



                    </div>

                </div >
            </Modal >
        </div>
    );
}

export default AddressManagementModal;